import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            alt="Oficina moderna con suministros"
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/ab41bf8f917eb5e56ac1959de00fb1ab.png"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/85 via-blue-800/80 to-blue-950/90"></div>
        </div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-24 sm:pt-28 pb-12 text-center transition-all duration-1000 opacity-100 translate-y-0">
          <div className="mb-6 sm:mb-8 flex justify-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-8 inline-block">
              <img
                alt="CX Comercializadora de Puebla"
                className="h-16 sm:h-24 w-auto filter brightness-0 invert"
                src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/03ddab0fb09532e94d7645cd24b4fbb6.png"
              />
            </div>
          </div>
          
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Tu Aliado Estratégico en<br />Suministros de Oficina
          </h1>
          
          <p className="text-base sm:text-lg lg:text-2xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-2">
            Proveedor líder de insumos empresariales en Puebla. Soluciones B2B y B2C con precios competitivos, entrega enfocada en tus necesidades y atención personalizada.
          </p>
          
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center px-2">
            <a
              href="https://wa.me/+522228121142"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-6 sm:px-10 py-4 rounded-lg text-sm sm:text-base font-semibold transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform flex items-center justify-center gap-3 shadow-xl w-full sm:w-auto"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Solicitar Cotización por WhatsApp
            </a>
            <Link
              to="/catalogo"
              className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border-2 border-white/50 px-6 sm:px-10 py-4 rounded-lg text-sm sm:text-base font-semibold transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform shadow-xl w-full sm:w-auto"
            >
              Ver Catálogo de Productos
            </Link>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 transition-all duration-1000 delay-500 opacity-100 translate-y-0">
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-3xl text-white"></i>
          </div>
        </div>
      </section>
      
      {/* Productos Destacados */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="text-center mb-12 sm:mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Productos Destacados</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
              Descubre nuestra selección de productos más solicitados por empresas en Puebla
            </p>
          </div>
          
          <div className="relative px-8 sm:px-12">
            <div className="overflow-hidden">
              <div className="grid gap-6 sm:gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                {/* Producto 1 */}
                <div className="bg-white rounded-xl border-2 border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-500 cursor-pointer hover:-translate-y-2 opacity-100 translate-y-0">
                  <div className="w-full h-56 sm:h-64 bg-gray-50 flex items-center justify-center p-6">
                    <img
                      alt="Paquete de Hojas Blancas Carta"
                      className="w-full h-full object-contain object-top"
                      src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/6ae1d10914139d9dd26442284d8c1024.png"
                    />
                  </div>
                  <div className="p-5 sm:p-6">
                    <div className="text-xs font-semibold text-blue-700 mb-2 uppercase tracking-wide">Papelería</div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Paquete de Hojas Blancas Carta</h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      Hojas blancas tamaño carta 70g/m² Xerox Marathon, resma de 500 hojas de alta calidad para impresión y copiado.
                    </p>
                    <a
                      href="https://wa.me/+522228121142"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold text-sm transition-colors cursor-pointer"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                      Solicitar por WhatsApp
                    </a>
                  </div>
                </div>
                
                {/* Producto 2 */}
                <div className="bg-white rounded-xl border-2 border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-500 cursor-pointer hover:-translate-y-2 opacity-100 translate-y-0">
                  <div className="w-full h-56 sm:h-64 bg-gray-50 flex items-center justify-center p-6">
                    <img
                      alt="Recopilador Verde Tamaño Carta"
                      className="w-full h-full object-contain object-top"
                      src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/8e4da39d175b92a0cfbfcd14f452b7a4.png"
                    />
                  </div>
                  <div className="p-5 sm:p-6">
                    <div className="text-xs font-semibold text-blue-700 mb-2 uppercase tracking-wide">Organización</div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Recopilador Verde Tamaño Carta</h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      Recopilador verde tamaño carta, marcas Kyma y Ofis. Ideal para archivar documentos de forma ordenada y duradera.
                    </p>
                    <a
                      href="https://wa.me/+522228121142"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold text-sm transition-colors cursor-pointer"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                      Solicitar por WhatsApp
                    </a>
                  </div>
                </div>
                
                {/* Producto 3 */}
                <div className="bg-white rounded-xl border-2 border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-500 cursor-pointer hover:-translate-y-2 opacity-100 translate-y-0">
                  <div className="w-full h-56 sm:h-64 bg-gray-50 flex items-center justify-center p-6">
                    <img
                      alt="Caja Bolígrafo Punto Fino Pin Point"
                      className="w-full h-full object-contain object-top"
                      src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/2cb3ffe0e384b539b7c1a95b9220ab95.png"
                    />
                  </div>
                  <div className="p-5 sm:p-6">
                    <div className="text-xs font-semibold text-blue-700 mb-2 uppercase tracking-wide">Escritura</div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Caja Bolígrafo Punto Fino Pin Point</h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      Caja de 12 piezas de bolígrafos punto fino Pin Point Azor color azul, escritura precisa y fluida.
                    </p>
                    <a
                      href="https://wa.me/+522228121142"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold text-sm transition-colors cursor-pointer"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                      Solicitar por WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-center gap-2 mt-8">
              <button className="min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer touch-manipulation transition-all scale-110" aria-label="Ir a slide 1">
                <span className="block rounded-full transition-all bg-blue-700 w-8 h-3"></span>
              </button>
              <button className="min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer touch-manipulation transition-all" aria-label="Ir a slide 2">
                <span className="block rounded-full transition-all bg-gray-300 w-3 h-3"></span>
              </button>
              <button className="min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer touch-manipulation transition-all" aria-label="Ir a slide 3">
                <span className="block rounded-full transition-all bg-gray-300 w-3 h-3"></span>
              </button>
              <button className="min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer touch-manipulation transition-all" aria-label="Ir a slide 4">
                <span className="block rounded-full transition-all bg-gray-300 w-3 h-3"></span>
              </button>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <Link
              to="/catalogo"
              className="inline-block bg-blue-700 hover:bg-blue-800 text-white px-8 sm:px-10 py-4 rounded-lg text-sm sm:text-base font-semibold transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform shadow-lg"
            >
              Ver Catálogo Completo
            </Link>
          </div>
        </div>
      </section>
      
      {/* Por Qué Elegir CX */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="text-center mb-12 sm:mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-700 bg-blue-50 px-4 py-1.5 rounded-full mb-4">
              Nuestra Propuesta de Valor
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 px-4">
              ¿Por Qué Elegir CX Comercializadora?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
              Somos tu socio estratégico en suministros de oficina — con ventajas competitivas y soluciones que marcan la diferencia
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
            <div className="bg-white rounded-xl p-6 sm:p-7 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-500 hover:-translate-y-1 opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-lg mb-4">
                <i className="ri-price-tag-3-line text-2xl text-blue-700"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">Precios Competitivos</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Mejores precios del mercado con descuentos especiales para compras corporativas y por volumen.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 sm:p-7 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-500 hover:-translate-y-1 opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-lg mb-4">
                <i className="ri-truck-line text-2xl text-blue-700"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">Entrega eficaz</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Entrega acorde a tus necesidades en Puebla y zona metropolitana. Envíos a diversas partes de la República Mexicana.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 sm:p-7 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-500 hover:-translate-y-1 opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-lg mb-4">
                <i className="ri-customer-service-2-line text-2xl text-blue-700"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">Atención Personalizada B2B</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Ejecutivos dedicados para empresas con cotizaciones personalizadas.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 sm:p-7 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-500 hover:-translate-y-1 opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-lg mb-4">
                <i className="ri-shopping-cart-line text-2xl text-blue-700"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">Compra B2C Simplificada</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                También atendemos clientes individuales con el mismo nivel de servicio y calidad.
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-blue-700 to-blue-900 rounded-2xl p-6 sm:p-10 lg:p-12 text-center transition-all duration-1000 delay-700 opacity-100 translate-y-0">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 px-2">
              ¿Listo para Optimizar tus Suministros de Oficina?
            </h3>
            <p className="text-base sm:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto px-2">
              Solicita una cotización personalizada y descubre cómo podemos ayudarte a reducir costos y mejorar tu operación
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center">
              <a
                href="https://wa.me/+522228121142"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-8 sm:px-10 py-4 rounded-lg text-base font-semibold transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Contactar Ahora
              </a>
              <Link
                to="/contacto"
                className="bg-white hover:bg-gray-100 text-blue-700 px-8 sm:px-10 py-4 rounded-lg text-base font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                Enviar Mensaje
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Home;